import "./style.scss";

import { ReactComponent as ArrowIcon } from "../../../../../../assets/icons/arrow.svg";

export default function AiClip() {
  return (
    <div className="ai-clip-animation">
      <img
        className="ai-clip-animation-img img-1"
        src={`${process.env.REACT_APP_BASENAME}/img/animations/ai-clip/img-1.webp`}
        alt="Clip animation"
      />
      <img
        className="ai-clip-animation-img img-2"
        src={`${process.env.REACT_APP_BASENAME}/img/animations/ai-clip/img-2.webp`}
        alt="Clip animation"
      />
      <img
        className="ai-clip-animation-img img-3"
        src={`${process.env.REACT_APP_BASENAME}/img/animations/ai-clip/img-3.webp`}
        alt="Clip animation"
      />
      <img
        className="ai-clip-animation-img img-4"
        src={`${process.env.REACT_APP_BASENAME}/img/animations/ai-clip/img-4.webp`}
        alt="Clip animation"
      />
      <img
        className="ai-clip-animation-img img-5"
        src={`${process.env.REACT_APP_BASENAME}/img/animations/ai-clip/img-5.webp`}
        alt="Clip animation"
      />
      <ArrowIcon className="ai-clip-animation-img img-6" />
    </div>
  );
}
